var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"confirmation-file-info"},[_c(_setup.ConfirmationSubTitle,{attrs:{"subTitle":'붙임',"styles":'margin-top: 28px'}}),_c('div',{staticStyle:{"border":"1px solid #ccc","padding":"16px 20px","font-size":"12px"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }